module.exports = __webpack_public_path__ + "img/JenniferPeve@2x.30ecd279.png";